import { BUILT_IN_COMPONENT_RECIPE_NAME_BY_COMPONENT, BUILT_IN_COMPONENT_VARIANTS, } from '@smoothie-framework/ui-styles/styling/contract';
export function createBuiltInComponentMeta(componentId) {
    return {
        componentId,
        recipeName: BUILT_IN_COMPONENT_RECIPE_NAME_BY_COMPONENT[componentId],
        recipeVariants: BUILT_IN_COMPONENT_VARIANTS[componentId],
    };
}
//# sourceMappingURL=built-in-component-meta.js.map